import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=20d061d0&scoped=true&"
var script = {}
import style0 from "./Login.vue?vue&type=style&index=0&id=20d061d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d061d0",
  null
  
)

export default component.exports